import React, { useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { Hero } from './components/Hero';
import { StatsRow } from './components/StatsRow';
import { ProcessTimeline } from './components/ProcessTimeline';
import { PortfolioGrid } from './components/PortfolioGrid';
import { LifestyleSlider } from './components/LifestyleSlider';
import { LocalExpertise } from './components/LocalExpertise';
import { Partners } from './components/Partners';
import { FieldNotes } from './components/FieldNotes';
import { Configurator } from './components/Configurator';
import { FooterCTA } from './components/FooterCTA';
import { Footer } from './components/Footer';
import { ArticlePage } from './pages/ArticlePage';
import { ProjectGallery } from './pages/ProjectGallery';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <div className="min-h-screen bg-[#F5F3F0] text-[#1A1A1A] font-sans selection:bg-[#A07656] selection:text-white" data-id="element-0">
      {/* Navigation Overlay */}
      <AnimatePresence data-id="element-1">
        {isMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 bg-[#1A1A1A] flex flex-col justify-center items-center" data-id="element-2">
            <button onClick={() => setIsMenuOpen(false)} className="absolute top-8 right-8 text-[#F5F3F0] hover:text-[#A07656] transition-colors" data-id="element-3">
              <X className="w-8 h-8" data-id="element-4" />
            </button>
            <nav className="text-center space-y-8" data-id="element-5">
              {[{
            label: 'Home',
            target: 'top'
          }, {
            label: 'Portfolio',
            target: 'portfolio'
          }, {
            label: 'About',
            target: 'about'
          }, {
            label: 'Blogs',
            target: 'field-notes'
          }, {
            label: 'Contact',
            target: 'contact'
          }].map((item, index) => <motion.a key={item.label} href={`#${item.target}`} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.1
          }} className="block text-4xl md:text-5xl font-serif font-semibold text-[#F5F3F0] hover:text-[#A07656] transition-colors" onClick={e => {
            e.preventDefault();
            setIsMenuOpen(false);
            setTimeout(() => {
              if (item.target === 'top') {
                window.scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              } else {
                const el = document.getElementById(item.target);
                if (el) {
                  el.scrollIntoView({
                    behavior: 'smooth'
                  });
                }
              }
            }, 300);
          }} data-id="element-6">
                  {item.label}
                </motion.a>)}
            </nav>
          </motion.div>}
      </AnimatePresence>

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-40 px-6 py-5 flex justify-between items-center" data-id="element-7">
        {/* Top gradient scrim for logo readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-transparent pointer-events-none" data-id="element-8" />
        <Link to="/" className="relative z-10" data-id="element-9">
          <img src="https://cdn.magicpatterns.com/uploads/rsVSuidRepyz9oxNYVg3rK/Iron_Ridge_Logo.png" alt="Iron Ridge Custom Homes" className="h-20 md:h-24 w-auto brightness-0 invert drop-shadow-[0_2px_16px_rgba(0,0,0,0.6)]" data-id="element-10" />
        </Link>
        <button onClick={() => setIsMenuOpen(true)} className="relative z-10 flex items-center gap-3 group" data-id="element-11">
          <span className="text-sm uppercase tracking-widest font-medium hidden md:block text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] group-hover:text-[#A07656] transition-colors" data-id="element-12">
            Menu
          </span>
          <Menu className="w-6 h-6 text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] group-hover:text-[#A07656] transition-colors" data-id="element-13" />
        </button>
      </header>

      <main data-id="element-14">
        <Hero data-id="element-15" />
        <StatsRow data-id="element-16" />
        <ProcessTimeline data-id="element-17" />
        <PortfolioGrid data-id="element-18" />
        <LifestyleSlider data-id="element-19" />
        <LocalExpertise data-id="element-20" />
        <Partners data-id="element-21" />
        <Configurator data-id="element-22" />
        <FieldNotes data-id="element-23" />
        <FooterCTA data-id="element-24" />
      </main>

      <Footer data-id="element-25" />
    </div>;
}
export function App() {
  return <Routes data-id="element-26">
      <Route path="/" element={<HomePage data-id="element-28" />} data-id="element-27" />
      <Route path="/articles/:slug" element={<ArticlePage data-id="element-30" />} data-id="element-29" />
      <Route path="/projects/:slug" element={<ProjectGallery data-id="element-32" />} data-id="element-31" />
    </Routes>;
}